import { useEffect, useState } from 'react';

const useDevicePixelRatio = () => {
  const [dpr, setDpr] = useState(() => window.devicePixelRatio || 1);

  useEffect(() => {
    const media = window.matchMedia(`(resolution: ${dpr}dppx)`);
    const handleChange = () => setDpr(window.devicePixelRatio || 1);
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, [dpr]);

  return dpr;
};

export default useDevicePixelRatio;
